// extracted by mini-css-extract-plugin
export default {"formContainer":"LoginForm_formContainer__-5XWz","form":"LoginForm_form__IFcDD","formHeader":"LoginForm_formHeader__0dAjg","formContent":"LoginForm_formContent__CjuiT"};